export default __webpack_public_path__ + "static/media/combo_ww.f880e809.png";